module.exports = __webpack_public_path__ + "static/media/8.e0c52e8f.jpg";